import { BasicProfileData } from '@careerhub/api';
import { UserProfileState } from '..';
import { IAppModuleState } from '../../models/IAppModuleState';
import { IAction, IActionFailed, IActionSuccess, IActionSuccessWithNoResult, LoadingStates } from '../common.types';
import * as actions from './actions';
import { IUserProfileState } from './types';
import { User } from '@microsoft/microsoft-graph-types';

// TODO remove unused slice
export const getInitialUserProfileState = (): IUserProfileState => {
  return {
    userProfilePicture: undefined,
    userProfileDetails: undefined,
    fetchProfileStatus: LoadingStates.NOT_STARTED,
    userProfilePictureFetchStatus: LoadingStates.NOT_STARTED,
    userProfileDetailsFetchStatus: LoadingStates.NOT_STARTED,
    hrProfile: undefined,
    errorMessage: '',
  };
};

export const userProfileStateSelector = (state: IAppModuleState) =>
  state[UserProfileState] ?? getInitialUserProfileState();

export function userProfileStateReducer(
  prev: IUserProfileState = getInitialUserProfileState(),
  action: IAction | IActionSuccess<string> | IActionSuccess<User> | IActionFailed | IActionSuccessWithNoResult
): IUserProfileState {
  switch (action.type) {
    case actions.UserProfileActionType.FETCH_MY_PROFILE_PICTURE:
      return {
        ...prev,
        userProfilePictureFetchStatus: LoadingStates.STARTED,
      };
    case actions.UserProfileActionType.FETCH_MY_PROFILE_PICTURE_FAILED:
      return {
        ...prev,
        userProfilePictureFetchStatus: LoadingStates.FAILED,
      };
    case actions.UserProfileActionType.FETCH_MY_PROFILE_PICTURE_SUCCESS:
      var userProfilePictureAction: IActionSuccess<string> = action as IActionSuccess<string>;
      return {
        ...prev,
        userProfilePictureFetchStatus: LoadingStates.SUCCEEDED,
        userProfilePicture: userProfilePictureAction.payload,
      };
    case actions.UserProfileActionType.LOAD_MY_HR_PROFILE:
      const newHrProfileStatus =
        prev.fetchProfileStatus === LoadingStates.NOT_STARTED ? LoadingStates.STARTED : prev.fetchProfileStatus;
      return {
        ...prev,
        fetchProfileStatus: newHrProfileStatus,
        errorMessage: '',
      };
    case actions.UserProfileActionType.LOAD_MY_HR_PROFILE_FAILED:
      return {
        ...prev,
        fetchProfileStatus: LoadingStates.FAILED,
        errorMessage: (action as IActionFailed).errorMessage,
      };
    case actions.UserProfileActionType.LOAD_MY_HR_PROFILE_SUCCESS:
      const fetchHrProfileAction = action as IActionSuccess<BasicProfileData>;
      return {
        ...prev,
        fetchProfileStatus: LoadingStates.SUCCEEDED,
        hrProfile: fetchHrProfileAction.payload,
      };
    case actions.UserProfileActionType.FETCH_MY_PROFILE_DETAILS:
      return {
        ...prev,
        userProfileDetailsFetchStatus: LoadingStates.STARTED,
      };
    case actions.UserProfileActionType.FETCH_MY_PROFILE_DETAILS_FAILED:
      return {
        ...prev,
        userProfileDetailsFetchStatus: LoadingStates.FAILED,
      };
    case actions.UserProfileActionType.FETCH_MY_PROFILE_DETAILS_SUCCESS:
      var userProfileDetailsAction: IActionSuccess<User> = action as IActionSuccess<User>;
      return {
        ...prev,
        userProfileDetailsFetchStatus: LoadingStates.SUCCEEDED,
        userProfileDetails: { ...userProfileDetailsAction.payload },
      };
    default:
      return prev;
  }
}
